import React, { createContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
// import analytics from "@react-native-firebase/analytics";

const ThemeContext = createContext({});

const Provider = ({ children }) => {
  const [activeTheme, setActiveTheme] = useState("amber");
  //   const { width: deviceWidth, height: deviceHeight } = ///;

  useEffect(() => {
    getTheme();
  }, []);

  return (
    <ThemeContext.Provider value={{ activeTheme, changeTheme, saveTheme,setActiveTheme }}>
      {children}
    </ThemeContext.Provider>
  );

  function changeTheme(theme) {
    setActiveTheme(theme);
  }

  async function getTheme() {
    try {
      const value = localStorage.getItem("@theme");
      if (value !== null) {
        setActiveTheme(value);
      } else {
        setActiveTheme("amber");
      }
    } catch (e) {
      setActiveTheme("amber");
    }
  }
  async function saveTheme(theme) {
    try {
      localStorage.setItem("@theme", theme);
    } catch (e) {
      // saving error
    }

    //Google analytics data logging
    // analytics().logEvent("theme_selected", { theme });
  }
};

ThemeContext.ProviderWrapper = Provider;

Provider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ThemeContext;
